import React, { useState } from 'react';
import Input from '../ui/Input';
import Button from '../ui/Button';

const AddTeacher = ({ setTeachers }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');

    const handleAddTeacher = (e) => {
        e.preventDefault();
        const newTeacher = { id: Date.now(), name, email };
        setTeachers(prevTeachers => [...prevTeachers, newTeacher]);
        setName('');
        setEmail('');
    };

    return (
        <form onSubmit={handleAddTeacher} className="mb-6">
            <h4 className="text-lg font-semibold mb-2">Add New Teacher</h4>
            <div className="flex flex-col space-y-2">
                <Input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} />
                <Input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                <Button type="submit">Add Teacher</Button>
            </div>
        </form>
    );
};

export default AddTeacher;
